export default __webpack_public_path__ + "static/media/banner.6248ba75.png";